<!-- Переключатель с доступным именем и частичным состоянием. -->
<template>
  <label class="item-switch">
    <input
      type="checkbox"
      :checked="modelValue"
      :indeterminate="indeterminate"
      :aria-label="ariaLabel"
      @change="handleChange"
      :disabled="disabled"
    />
    <span
      class="slider"
      :class="{ 'is-indeterminate': indeterminate }"
    ></span>
  </label>
</template>

<script>
export default {
  name: "base-toggle-switch",
  props: {
    indeterminate: { type: Boolean, default: false },
    ariaLabel: { type: String, default: null },
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    handleChange(event) {
      this.$emit("update:modelValue", event.target.checked);
      // При асинхронном сохранении показываем подтверждённое значение родителя.
      this.$nextTick(() => {
        event.target.checked = this.modelValue;
        event.target.indeterminate = this.indeterminate;
      });
    },
  },
};
</script>

<style scoped>
.item-switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
  flex-shrink: 0;
}

.item-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--color-green);
}

input:checked + .slider:before {
  transform: translateX(20px);
}

input:disabled + .slider {
  opacity: 0.6;
  cursor: not-allowed;
}

input:focus-visible + .slider {
  outline: 2px solid var(--color-green);
  outline-offset: 4px;
}
.slider.is-indeterminate {
  background-color: var(--color-green);
  opacity: 0.6;
}
.slider.is-indeterminate:before {
  transform: translateX(10px);
}
</style>
